import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ProgrammeForm from '../Form';
import { createProgramme } from '@resources/Programme/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { module, createProgramme, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createProgramme(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.programme.create',
						defaultMessage:
							'A new Programme has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.programme',
					defaultMessage: 'Create Programme',
				})}
			</Title>
			<Section className="mb-5">
				<ProgrammeForm
					onSubmit={handleSubmit}
					{...props}
					module={module}
				/>
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	programmes,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		programmes,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createProgramme,
})(Create);
